module.exports = __webpack_public_path__ + "img/users-primary.6d1c0a2.png";